'use strict';

import { Color, Fog, ShaderMaterial } from 'three';
import stormVertex from '../threejs/Shaders/weather/thunderstorm/vertexShader.glsl';
import stormFragment from '../threejs/Shaders/weather/thunderstorm/fragmentShader.glsl';
import { PostFX } from '../post-processing/PostFX';
import { projectMode, threeJsVariables } from '../../settings';
import * as dat from 'dat.gui';
import { basic_tile } from '../threejs/environment';

export class Thunderstorm {
    constructor () {

        this.fogColor = new Color(0.37,0.37,0.37);
        this.envFogDensity = 0.0015;
        this.bgFogDensity = 0.0015;

        const options = {
            rainSpatialDensityX: 100.0,
            rainSpatialDensityY: 33.0,
            rainMaxDensity: 1.0,
            rainSpeed: 35.0,
            dropletLength: 1.0,
            dropletWidth: 0.01
        };


        this.material = new ShaderMaterial({
            vertexShader: stormVertex,
            fragmentShader: stormFragment,
            uniforms: {
                uTime: {
                    value: 0
                },
                rainSpatialDensityX: {
                    value: options.rainSpatialDensityX
                },
                rainSpatialDensityY: {
                    value: options.rainSpatialDensityY
                },
                rainMaxDensity: {
                    value: options.rainMaxDensity
                },
                rainSpeed: {
                    value: options.rainSpeed
                },
                dropletLength: {
                    value: options.dropletLength
                },
                dropletWidth: {
                    value: options.dropletWidth
                }
            }
        });

        this.effect = new PostFX('thunderstorm',threeJsVariables.renderer,this.material);

        // const gui = new dat.GUI();
        //
        // gui.add(options,'rainSpatialDensityX',0.0,100.0, 0.01).onChange((v) =>{
        //     this.material.uniforms.rainSpatialDensityX.value = v;
        // });
        //
        // gui.add(options,'rainSpatialDensityY',0.0,100.0,0.01).onChange((v) =>{
        //     this.material.uniforms.rainSpatialDensityY.value = v;
        // });
        //
        // gui.add(options,'rainMaxDensity',0.0,100.0,0.01).onChange((v) =>{
        //     this.material.uniforms.rainMaxDensity.value = v;
        // });
        //
        // gui.add(options,'rainSpeed',0.0,100.0,0.01).onChange((v) =>{
        //     this.material.uniforms.rainSpeed.value = v;
        // });
        //
        // gui.add(options,'dropletLength',0.0,100.0,0.01).onChange((v) =>{
        //     this.material.uniforms.dropletLength.value = v;
        // });
        //
        // gui.add(options,'dropletWidth',0.0,100.0,0.01).onChange((v) =>{
        //     this.material.uniforms.dropletWidth.value = v;
        // });

        return this;
    }

    enable() {
        this.effect.enable();

        if (!projectMode.LiteMode.isActive()) {

            /* ENV FOG */
            basic_tile.uniforms.fogColor.value.copy(this.fogColor);
            basic_tile.uniforms.fogDensity.value = this.envFogDensity;

            if (threeJsVariables.tilesRenderer){
                threeJsVariables.tilesRenderer.forEachLoadedModel((scene,tile)=>{
                    scene.traverse(obj => {
                        if ( obj.material) {
                            obj.material.uniforms.fogColor.value.copy(this.fogColor);
                            obj.material.uniforms.fogDensity.value = this.envFogDensity;
                        }
                    });
                });
            } else {
                let env = threeJsVariables.scene.getObjectByName('async env');
                env.traverse(obj => {
                    if ( obj.material) {
                        obj.material.uniforms.fogColor.value.copy(this.fogColor);
                        obj.material.uniforms.fogDensity.value = this.envFogDensity;
                    }
                });
            }

            /* BG FOG */
            const bg = threeJsVariables.scene.getObjectByName('Background');
            bg.traverse(obj => {
                if (obj.material) {
                    obj.material.uniforms.fogColor.value.copy(this.fogColor);
                    obj.material.uniforms.fogDensity.value = this.bgFogDensity;
                }
            });

            /* SCENE FOG */
            threeJsVariables.scene.fog = new Fog(new Color().copy(this.fogColor),1.0,825);
        }
    }

    disable() {
        this.effect.disable();

        if (!projectMode.LiteMode.isActive()) {

            /* ENV FOG */
            basic_tile.uniforms.fogDensity.value = 0.0;

            if (threeJsVariables.tilesRenderer){
                threeJsVariables.tilesRenderer.forEachLoadedModel((scene,tile)=>{
                    scene.traverse(obj => {
                        if ( obj.material) {
                            obj.material.uniforms.fogDensity.value = 0.0;
                        }
                    });
                });
            } else {
                let env = threeJsVariables.scene.getObjectByName('async env');
                env.traverse(obj => {
                    if ( obj.material) {
                        obj.material.uniforms.fogDensity.value = 0.0;
                    }
                });
            }

            /* BG FOG */
            const bg = threeJsVariables.scene.getObjectByName('Background');
            bg.traverse(obj => {
                if (obj.material) {
                    obj.material.uniforms.fogDensity.value = 0.0;
                }
            });

            /* SCENE FOG */
            threeJsVariables.scene.fog = null;
        }
    }

    update(time) {
        if (this.effect.active) {
            this.material.uniforms.uTime.value = time;
        }
    }


}